export default {
	// actions
	actionsText: {
		view: "Ver",
		edit: "Editar",
		delete: "Deletar",
		"*": "Ações",
	},

	// per page
	perPageText: "Exibindo :entries dados",

	// entries info
	infoText: "Exibindo :first até :last de :total dados",
	infoTextFiltered:
		"Exibindo :first até :last de :filtered (filtrado de :total dados)",

	// pagination
	nextButtonText: "Próximo",
	previousButtonText: "Anterior",

	paginationSearchText: "Ir para página",
	paginationSearchButtonText: "IR",

	// search filter
	searchText: "pesquisar:",
	emptyTableText: "Nenhum dado correspondente à pesquisa foi encontrado",

	// export data
	downloadText: "exportar como:",
	downloadButtonText: "BAIXAR"
};
